module.exports = __webpack_public_path__ + "static/media/gal2010-27.22fe5a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-27.jpg
// module id = 580
// module chunks = 0